function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckThin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m59.438 10.914-36.847 36.845a2.6664 2.6664 0 0 1-3.7783 0l-14.249-14.263a2.6664 2.6664 0 0 0-3.7783 0 2.6664 2.6664 0 0 0 0 3.7783l14.255 14.252a8.0206 8.0206 0 0 0 11.332 0l36.845-36.837a2.6664 2.6664 0 0 0 0-3.7757 2.6664 2.6664 0 0 0-3.7783 0z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6664
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThin);
export default __webpack_public_path__ + "static/media/check-thin.892d48f6.svg";
export { ForwardRef as ReactComponent };